import { render, staticRenderFns } from "./SettingsCredentials.vue?vue&type=template&id=203c620a&scoped=true"
import script from "./SettingsCredentials.vue?vue&type=script&lang=js"
export * from "./SettingsCredentials.vue?vue&type=script&lang=js"
import style0 from "./SettingsCredentials.vue?vue&type=style&index=0&id=203c620a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203c620a",
  null
  
)

export default component.exports